export const RegexEnum = {
  NUMERO_EXPEDIENTE: [/[A-Z]/, "-", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, "-", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
  CODIGO_AGENCIA: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[1-9]/],
  NUMERO_SECUENCIA: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, "-", /[0-9]/],
  DECIMAL_SIX: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ".", /[0-9]/, /[0-9]/],
  DECIMAL_SEVEN: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ".", /[0-9]/, /[0-9]/],
  EXPEDIENTE: [
    /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, // Up to 6 digits
    /-/, // Optional first dash
    /\d/, // Optional single digit
    /-/, // Optional second dash
    /\d/, // Optional single digit
    '.',  // Decimal point
    /\d/, /\d/  // Exactly 2 digits after the decimal
  ]
};